import {
    FETCH_BILLING_DETAILS,
    LOG_OUT_USER,
    UPDATE_SMS_ALERT_PREFERENCES,
    UPDATE_BILLING_PLAN,
    CANCEL_CARD_SUBSCRIPTION
} from '../../actions/actionTypes';

const fetchBillingDetailsReducer = (billing, payload) => {
    let new_constants = {};
    if(payload.constants){
        for(let c of payload.constants){
            new_constants[c.name] = c.value;
        }
    }

    let newBilling = {
        customerAccount: payload.customerAccount,
        constants : new_constants
    };
    return newBilling;
}

const updateSmsAlertPreferencesReducer = (billing, payload) => {
    let new_constants = {...billing.constants};
    let newBilling = {
        customerAccount: payload.customerAccount,
        constants : new_constants
    };
    return newBilling;
}

const updateBillingPlanReducer = (billing, payload) => {
    return {
        ...billing,
        customerAccount: payload.customerAccount
    };
}

const updateActiveCardSubscription = (billing, payload) => {
    let currentAccount = billing.customerAccount
    let newAccount = {...currentAccount,hasActiveCardSubscription:false}
    let newBilling = {
        ...billing,
        customerAccount: newAccount
    }
    return newBilling;
}

const BillingReducer = (state={}, action) => {
    let billing = state;
    if (action && action.payload && !action.payload.errors){
        switch(action.type){
            case FETCH_BILLING_DETAILS:
                return fetchBillingDetailsReducer(billing, action.payload);
            case UPDATE_SMS_ALERT_PREFERENCES:
                return updateSmsAlertPreferencesReducer(billing, action.payload);
            case CANCEL_CARD_SUBSCRIPTION:
                return updateActiveCardSubscription(billing, action.payload);
            case UPDATE_BILLING_PLAN:
                return updateBillingPlanReducer(billing, action.payload);
            default:
                return billing;
        }
    }

    if (action.type === LOG_OUT_USER){
        billing = {}
    }
    return billing;
}

export default BillingReducer;